export enum TaskTypeKeyEnum {
  UNLOADING = 'UNLOADING',
  LOADING = 'LOADING',
  ADDITIONAL_LOADING = 'ADDITIONAL_LOADING',
  CONTAINER_LOADING = 'CONTAINER_LOADING',
  CONTAINER_UNLOADING = 'CONTAINER_UNLOADING',
  CONTAINER_INSERTION = 'CONTAINER_INSERTION',
  CONTAINER_PICKUP = 'CONTAINER_PICKUP',
  MAUSER_LOADING = 'MAUSER_LOADING',
  MAUSER_UNLOADING = 'MAUSER_UNLOADING',
  MAUSER_INSERTION = 'MAUSER_INSERTION',
  MAUSER_PICKUP = 'MAUSER_PICKUP',
}

export enum TaskTypeValueIntGroupingEnum {
  LOADINGS = 1,
  UNLOADING = 2,
}